document.addEventListener('DOMContentLoaded', () => {
    const players = document.querySelectorAll('.wp-block-ifdigital-if-turntable--player');

    players.forEach((player) => {
        const container = player.closest('.wp-block-ifdigital-if-turntable');
        const tracksAttr = container?.getAttribute('data-tracks');
        if (!tracksAttr) {
            console.error('Das data-tracks-Attribut ist nicht gesetzt oder leer.');
            return;
        }

        let tracks;
        try {
            tracks = JSON.parse(tracksAttr);
        } catch (error) {
            console.error('Fehler beim Parsen von data-tracks:', error);
            return;
        }

        if (!tracks.length) {
            console.error('Keine Tracks gefunden.');
            return;
        }

        const audio = player.querySelector('audio');
        const playPauseButton = player.querySelector('.play-pause');
        const nextButton = player.querySelector('.next');
        const forwardButton = player.querySelector('.forward');
        const progressBar = player.querySelector('.progress-bar');
        const titleElement = player.querySelector('.current-track-title p');

        let currentTrackIndex = 0;
        let isPlaying = false;

        const loadTrack = (index) => {
            currentTrackIndex = index;
            audio.src = tracks[currentTrackIndex].url;
            titleElement.textContent = tracks[currentTrackIndex].title || 'Unbekannter Titel';
            audio.load();
            if (isPlaying) {
                audio.play();
            }
        };

        const togglePlayPause = () => {
            const playPauseIcon = playPauseButton.querySelector('img');

            if (audio.paused) {
                audio.play();
                isPlaying = true;
                if (container) {
                    container.classList.add('is-style-playing');
                }
                playPauseIcon.src = 'https://development.if.digital/2024.grease-musical.de/wp-content/plugins/if-turntable/includes/img/pause.svg';
                playPauseIcon.alt = 'Pause';
            } else {
                audio.pause();
                isPlaying = false;
                if (container) {
                    container.classList.remove('is-style-playing');
                }
                playPauseIcon.src = 'https://development.if.digital/2024.grease-musical.de/wp-content/plugins/if-turntable/includes/img/play.svg';
                playPauseIcon.alt = 'Play';
            }
        };

        const playNextTrack = () => {
            currentTrackIndex = (currentTrackIndex + 1) % tracks.length;
            loadTrack(currentTrackIndex);
        };

        const forwardTrack = () => {
            audio.currentTime = Math.min(audio.currentTime + 10, audio.duration);
        };

        const updateProgress = () => {
            if (audio.currentTime && audio.duration) {
                const progress = (audio.currentTime / audio.duration) * 100;
                progressBar.style.width = `${progress}%`;
            }
        };

        playPauseButton.addEventListener('click', togglePlayPause);
        nextButton.addEventListener('click', playNextTrack);
        forwardButton.addEventListener('click', forwardTrack);

        audio.addEventListener('timeupdate', updateProgress);
        audio.addEventListener('ended', playNextTrack);

        loadTrack(0);
    });
});